import { connect } from 'react-redux';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';
import * as selectors from '../../selectors';
import LocaleSwitcher from './LocalesSwitcher.component';
import * as configSelector from 'domains/core/config/selectors';
import * as locales from 'domains/core/locales';

const mapStateToProps = state => ({
  selectedLocale: selectors.selectedLocale(state),
  supportedLanguages: configSelector.supportedLanguages(state),
  localesMessages: configSelector.localeMessages(state),
  loadingSwitchLocale: selectors.loadingSwitchLocale(state),
});

const mapDispatchToProps = dispatch => ({
  switchLanguages: locale =>
    dispatch(locales.operations.fetchSwitchedLocale(locale)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl
)(LocaleSwitcher);
